<template>
    <v-container>
        <h1 class="titulo mb-3">Relatórios</h1>
        <v-card class="card">
            <v-card-text>
                <m-form ref="filter">
                    <v-row>
                        <v-col> <h2 class="mb-3">Informe os dados para a geração do relatório</h2> </v-col>
                        <v-col cols="12">
                            <v-select
                                    label="Empresas: "
                                    placeholder="Selecione a empresa"
                                    class="required"
                                    outlined
                                    :items="empresas"
                                    item-text="NM_Empresa"
                                    item-value="ID_Empresa"
                                    :rules="[$rules.required]"
                                    v-model="filters.id_empresa" />
                        </v-col>
                    </v-row>
                    <collapse-transition>
                        <v-row v-if="filter_open">
                            <v-col cols="6">
                                <DateField label="Data inicial:"
                                           v-model="filters.data_inicial"
                                           max="today"
                                           :rules="[$rules.required,validaDataInicial]" />
                            </v-col>
                            <v-col cols="6">
                                <DateField label="Data final:"
                                           v-model="filters.data_final"
                                           max="today"
                                           :rules="[$rules.required,dataValida,validaDataFinal]" />
                            </v-col>
                        </v-row>
                    </collapse-transition>
                    <v-row>
                        <v-col>
                            <h3>Agrupar por:</h3>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" offset="3" style="padding-top: 9px;">
                            <SlideButton :values="['Dia', 'Mês']" v-model="filters.is_diario" />
                        </v-col>
                    </v-row>
                    <v-row style="padding-top:10px;" class="justify-space-between">
                        <v-btn color="secondary" @click="limpar">
                            Limpar
                        </v-btn>
                        <v-btn color="primary" @click="gerar">
                            Gerar
                        </v-btn>
                    </v-row>
                </m-form>
            </v-card-text>
        </v-card>

        <v-card v-if="show_relatorio" style="margin-top: 25px;" class="card">
            <v-card-text>
                <DataTable ref="datatable" url="/painel/relatorio/gerar"
                           class="pt-2 data-table-overlow"
                           :headers="headers"
                           :params="params"
                           :filter="dtFiltro"
                           :hide-footer="true"
                           :show-total="true">
                    <template v-slot:items="{item}">
                        <td v-if="filters.is_diario">{{ toDateBR(item.data) }}</td>
                        <td v-else>{{ Meses[item.data - 1] }}</td>
                        <td>
                            {{ item.boleto }}
                        </td>
                        <td>
                            {{ item.link }}
                        </td>
                        <td>
                            {{ item.cartao }}
                        </td>
                        <td>
                            {{ item.venda_reserva }}
                        </td>
                        <td>
                            {{ item.rascunho }}
                        </td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import { Meses } from '@/plugins/constants'
  import { toDateBR } from '@/plugins/formatters'
  import moment from 'moment'

  export default {
    name: 'Relatorios',
    data: () => ({
      headers: [
        { text: '', value: 'data' },
        { text: 'Boleto', value: 'boleto' },
        { text: 'Link', value: 'link' },
        { text: 'Cartão', value: 'cartao' },
        { text: 'Vendas com reserva', value: 'venda_reserva' },
        { text: 'Propostas em rascunho', value: 'rascunho' }
      ],
      pagination: {
        sortBy: [ 'data' ], descending: [ true ], rowsPerPage: 31, items_grid: 31
      },
      filter_open: true,
      show_relatorio: false,
      dtFiltro: {},
      rowsperpage: 31,
      filters: {
        id_empresa: 0,
        data_inicial: '',
        data_final: '',
        is_diario: true
      }
    }),
    computed: {
      ...mapState([ 'empresas' ]),
      params () {
        return { pagination: this.pagination }
      },
      Meses: () => Meses,
      dataValida () {
        return () => {
          var date1 = new Date(this.filters.data_inicial)
          var date2 = new Date(this.filters.data_final)
          var timeDiff = Math.abs(date2.getTime() - date1.getTime())
          var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
          if (this.filters.is_diario && diffDays > 31) {
            return 'Maior que 31 dias'
          } else if (!this.filters.is_diario && diffDays > 365) {
            return 'Maior que 365 dias'
          } else {
            return true
          }
        }
      }
    },
    watch: {
      filters: {
        handler (val) {
          this.show_relatorio = false
        },
        deep: true
      }
    },
    methods: {
      toDateBR (val) {
        return val.includes('-') ? toDateBR(val) : val
      },
      toggleFiltro () {
        this.filter_open = !this.filter_open
      },
      gerar () {
        if (this.$refs.filter.validate()) {
          this.show_relatorio = true
          this.dtFiltro = { ...this.filters }
        } else {
          this.show_relatorio = false
        }
      },
      limpar () {
        this.filters = {
          id_empresa: 0,
          data_inicial: '',
          data_final: ''
        }
      },
      validaDataFinal () {
        const now = moment().format('YYYY-MM-DD')
        const data_inicial = moment(this.filters.data_inicial)
        const data_final = moment(this.filters.data_final)

        if (data_inicial.isValid() && data_final.isBefore(data_inicial)) {
          return 'Data Final não pode ser menor que a Data Inicial!'
        }
        if (data_final.isAfter(now)) {
          return 'Data Final não pode ser maior que a data atual'
        }

        return true
      },
      validaDataInicial () {
        const now = moment().format('YYYY-MM-DD')
        const data_inicial = moment(this.filters.data_inicial)
        const data_final = moment(this.filters.data_final)

        if (data_inicial.isValid() && data_final.isBefore(data_inicial)) {
          return 'Data Inicial não pode ser maior que a Data Final!'
        }

        if (data_inicial.isAfter(now)) {
          return 'Data Inicial não pode ser maior que a data atual'
        }

        return true
      }
    }
  }
</script>

<style scoped>

</style>
